// This file is automatically generated by copy-versions.ts script

export const application = {version: '1.2.0', revision: '', branch: ''};
export const dependencies = {nx: '', cli: '', core: '', mat: '', rxjs: '', svgjs: '', ts: '', webpack: ''};
export const date = '2024-06-06T12:03:49.080Z';
